module.exports = __webpack_public_path__ + "img/abimg7.615a1ce3.png";